import React from "react";
import { CDropDown, CTag } from "@appcues/component-library";

const TagDropDown = props => (
  <CDropDown {...props} components={{ InnerOption }} />
);

const InnerOption = ({ isHovering, ...props }) => (
  <CTag {...props} forceHover={isHovering} />
);

export default TagDropDown;
